export enum SetType {
    STATUS = 'status',
    RATING = 'rating',
    WORKSPACE = 'workspace',
}
